import { Landmark, Cpu, ArrowLeftRight, ArrowRight } from "lucide-react";
import { Reveal } from "@/lib/anim";

const STAGES = [
  { icon: Landmark, title: "Bank", desc: "Core banking host · files · portals", accent: false },
  { icon: Cpu, title: "Automation Layer", desc: "iJeeva emulation engine · no-code rules", accent: true },
  { icon: ArrowLeftRight, title: "Payment Flow", desc: "Transfers · status · reconciliation", accent: false },
];

const LOG = [
  { time: "10:02:11", tag: "DETECT", tagClass: "text-amber-400", text: "Format drift detected in bank statement parser" },
  { time: "10:02:12", tag: "ANALYZE", tagClass: "text-sky-400", text: "Field mapping delta isolated · confidence 98.2%" },
  { time: "10:02:14", tag: "HEAL", tagClass: "text-teal-300", text: "Parser regenerated · regression checks passed" },
  { time: "10:02:20", tag: "DEPLOY", tagClass: "text-emerald-400", text: "Change promoted to production · zero downtime" },
];

export default function EmulationFlow() {
  return (
    <div data-testid="emulation-flow-visual">
      <div className="grid items-stretch gap-3 sm:grid-cols-[1fr_auto_1fr_auto_1fr]">
        {STAGES.map((s, i) => (
          <div key={s.title} className="contents">
            <Reveal
              delay={i * 110}
              className={`rounded-2xl border p-5 ${
                s.accent
                  ? "border-[#2563EB]/30 bg-[#2563EB]/[0.05]"
                  : "border-[#E2E8F0] bg-white shadow-[0_1px_2px_rgba(15,23,42,0.04)]"
              }`}
            >
              <div
                className={`flex h-10 w-10 items-center justify-center rounded-[10px] border ${
                  s.accent ? "border-[#2563EB]/30 bg-white text-[#2563EB]" : "border-[#E2E8F0] bg-[#F8FAFC] text-[#1D305B]"
                }`}
              >
                <s.icon className="h-5 w-5" />
              </div>
              <p className="mt-4 text-[15px] font-semibold text-[#1D305B]">{s.title}</p>
              <p className="mt-1 text-[12.5px] leading-relaxed text-[#64748B]">{s.desc}</p>
            </Reveal>
            {i < STAGES.length - 1 && (
              <div className="hidden items-center sm:flex" aria-hidden="true">
                <ArrowRight className="h-5 w-5 text-[#94A3B8]" />
              </div>
            )}
          </div>
        ))}
      </div>

      <Reveal delay={220} className="mt-5 overflow-hidden rounded-2xl bg-[#1D305B]">
        <div className="flex items-center justify-between border-b border-white/10 px-4 py-2.5">
          <p className="font-mono-brand text-[11px] text-white/60">emulation-engine · live events</p>
          <span className="flex items-center gap-1.5 text-[10.5px] font-medium text-teal-300">
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-teal-300" />
            AUTO-HEALING ACTIVE
          </span>
        </div>
        <div className="space-y-2.5 px-4 py-4">
          {LOG.map((l) => (
            <p key={l.time} className="font-mono-brand text-[11.5px] leading-relaxed text-white/70">
              <span className="text-white/35">{l.time}</span> <span className={`font-semibold ${l.tagClass}`}>[{l.tag}]</span>{" "}
              {l.text}
            </p>
          ))}
        </div>
      </Reveal>
    </div>
  );
}
